
export const environment = {
  production: false,
  API_URL: 'http://corpora.lancs.ac.uk/',
  API_BASE_URL: 'http://corpora.lancs.ac.uk:8088/api/',
  SOCKET_URL: 'http://corpora.lancs.ac.uk:8088/'
};




// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/environments/environment.ts